module.exports = __webpack_public_path__ + "static/media/login-background.f2a18f34.png";